import { RegisterRequestedFieldType } from "../requested-field-types"
import { RequestedFieldInput, RequestedFieldValue } from "../share-link-fields-slot-definitions"
import { RichTextFieldInput } from "../rich-text-field-input"
import { RichTextFieldValue } from "../rich-text-field-value"

/**
 * Self-registering plugin for the "richText" requested-field type. Registers the type's metadata and
 * plugs its recipient input + read-only value renderers.
 */
RegisterRequestedFieldType.handleOnce(({ types }) =>
    types.push({ value: "richText", label: "Rich text", priority: 20 })
)

RequestedFieldInput("richText").plug(<RichTextFieldInput />)
RequestedFieldValue("richText").plug(<RichTextFieldValue />)
